import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { AdminTable } from "./AdminTable";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

const STATUSES = ["pending", "verified", "rejected"];

export default function AdminPayments() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/payments").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const changeStatus = async (r, status) => {
    await api.patch(`/admin/payments/${r.id}`, { status });
    toast.success(`Marked ${status}`);
    load();
  };

  const download = (r) => {
    if (!r.screenshot_data) { toast.error("No screenshot attached."); return; }
    const a = document.createElement("a");
    a.href = r.screenshot_data;
    a.download = r.screenshot_name || `payment-${r.id.slice(0,8)}`;
    a.click();
  };

  return (
    <div data-testid="admin-payments">
      <h1 className="font-serif text-4xl">Payments</h1>
      <p className="text-foreground/60 mb-6 mt-1">Payment proofs submitted by clients & students.</p>

      <AdminTable
        testIdPrefix="pay-row"
        columns={[
          { key: "name", label: "Name" },
          { key: "phone", label: "Contact", render: (r) => <div><div className="text-xs">{r.phone}</div><div className="text-xs text-foreground/60">{r.email}</div></div> },
          { key: "service", label: "Service" },
          { key: "transaction_id", label: "TXN ID", render: (r) => <code className="text-[#D4AF37] text-xs">{r.transaction_id}</code> },
          { key: "screenshot_data", label: "Proof", render: (r) => r.screenshot_data ? <Button size="sm" variant="outline" className="rounded-full h-8 px-3 text-xs" onClick={() => download(r)}>Download</Button> : <span className="text-xs text-foreground/40">—</span> },
          { key: "status", label: "Status", render: (r) => (
            <Select value={r.status} onValueChange={(v) => changeStatus(r, v)}>
              <SelectTrigger className="w-32 rounded-full text-xs" data-testid={`pay-status-${r.id}`}><SelectValue /></SelectTrigger>
              <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
            </Select>
          ) },
        ]}
        rows={rows}
      />
    </div>
  );
}
